export const MAX_SELECTABLE_GENRE_TAGS = 3
